import { cn } from '@strivelabs/ui-core/lib/utils';

/**
 * How many things a named section holds.
 *
 * One component for every surface that counts a list — Strive updates, the
 * tasks card on the homepage, the panel's Notes and Outputs — because three
 * copies of the same pill is three chances for one of them to drift. The
 * design's own `.td-count`: a 16px capsule, 17px at its narrowest so a single
 * digit still reads as a pill, on the ink at 5.5% and in the third grey.
 *
 * Written next to the label rather than inside it, so a heading in the serif
 * does not pull the number in with it.
 */
export const CountPill = ({ count, className }: { count: number; className?: string }) => (
  <span
    className={cn(
      'inline-flex h-4 min-w-[17px] items-center justify-center rounded-full',
      'bg-[rgba(24,24,24,0.055)] px-[5px] font-sans text-[11px] font-normal',
      'tracking-[0.04em] text-[#9A9A9A]',
      className,
    )}
  >
    {count}
  </span>
);
